<template>
  <div class="content compliance-content">
    <div class="columns" v-for="(value, index) in contentData" :key="index">
      <div class="column content-name">{{ value.name }}</div>
      <div class="column fees">
        {{ value.total_fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
        <span v-if="value.total_fee != 'NA'">{{
          value.currency ? "&nbsp;" + value.currency : " EUR"
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ComplianceContentComp",
  props: {
    data: []
  },
  data() {
    return {
      contentData: this.data
    };
  },
  watch: {
    data(newValue) {
      this.contentData = newValue;
    }
  }
};
</script>
